import React from 'react';
import { formatTime } from '@/utils';
import { Divider } from '@alifd/next';
import { Tooltip } from '@b-design/fusion';
import $i18n from '../../../../i18n';

export interface WorkflowItemType {
  id: number;
  /**
   * 工作流ID
   */
  identify: string;
  /**
   * 名称
   */
  name: string;
  /**
   * 别名
   */
  alias: string;
  /**
   * 描述
   */
  description: string;
  /**
   * 类型
   */
  type: string;
  /**
   * 最新版本
   */
  version: string;
  /**
   * 创建时间
   */
  gmtCreate: string;
  /**
   * 更新时间
   */
  gmtModified: string;
  /**
   * 是否定制 0:否，1:是
   */
  isCustom: 0 | 1;
  /**
   * 卡片图片
   */
  image: string;
  /**
   * 轮播图图片
   */
  imageList: string;
}

export const FilterKeys = [
  {
    key: 'search',
    label: $i18n.get({
      id: 'aopf.component.workflowManagement.const.WorkflowName',
      dm: '工作流名称',
    }),
  },
];

export const CardTypeList = [
  {
    key: 'table',
    img: 'https://gw.alicdn.com/imgextra/i3/O1CN01NEacjM1aObxDIprpc_!!6000000003320-2-tps-48-48.png',
    activeImg:
      'https://gw.alicdn.com/imgextra/i1/O1CN01U437fe27sjJxxfaVu_!!6000000007853-2-tps-48-48.png',
  },
  {
    key: 'card',
    img: 'https://gw.alicdn.com/imgextra/i2/O1CN01B5QnZc27EsrXMqoc8_!!6000000007766-2-tps-48-48.png',
    activeImg:
      'https://gw.alicdn.com/imgextra/i3/O1CN01aFoEDc1eX5kcKyBOR_!!6000000003880-2-tps-48-48.png',
  },
];

export const RenderTooltip = (tooltipText, trigger?: any) => {
  if (!tooltipText) return trigger || '';
  return (
    <Tooltip align="t" trigger={trigger || <span>{tooltipText}</span>}>
      {tooltipText}
    </Tooltip>
  );
};

export const GetColumns = (
  viewDetails: (item: any) => void,
  onItemClick: (key: string, item: any) => void,
) => {
  return [
    {
      title: $i18n.get({
        id: 'aopf.component.workflowManagement.const.WorkflowId',
        dm: '工作流ID',
      }),
      dataIndex: 'identify',
      width: 170,
      cell: (value, _, record) => {
        return (
          <div className="workflow-id-cell">
            {RenderTooltip(
              value,
              <span className="id" onClick={() => viewDetails && viewDetails(record)}>
                {value}
              </span>,
            )}
            {`${record?.isCustom}` === '1' && (
              <span className="tag">
                {$i18n.get({
                  id: 'aopf.component.workflowManagement.const.Customization',
                  dm: '定制',
                })}
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: $i18n.get({
        id: 'aopf.component.workflowManagement.const.WorkflowName',
        dm: '工作流名称',
      }),
      dataIndex: 'name',
      width: 160,
      cell: (value) => <div className="workflow-ellipsis-cell">{RenderTooltip(value)}</div>,
    },
    {
      title: $i18n.get({
        id: 'aopf.component.workflowManagement.const.WorkflowAlias',
        dm: '工作流别名',
      }),
      dataIndex: 'alias',
      width: 160,
      cell: (value) => <div className="workflow-ellipsis-cell">{RenderTooltip(value)}</div>,
    },
    {
      title: $i18n.get({
        id: 'aopf.component.workflowManagement.const.WorkflowDescription',
        dm: '工作流描述',
      }),
      dataIndex: 'description',
      width: 180,
      cell: (value) => <div className="workflow-ellipsis-cell">{RenderTooltip(value)}</div>,
    },
    {
      title: $i18n.get({ id: 'aopf.component.workflowManagement.const.Type', dm: '类型' }),
      dataIndex: 'type',
      width: 160,
      cell: (value) => <div className="workflow-ellipsis-cell">{RenderTooltip(value)}</div>,
    },
    {
      title: $i18n.get({
        id: 'aopf.component.workflowManagement.const.LatestVersion',
        dm: '最新版本',
      }),
      dataIndex: 'version',
      width: 130,
      cell: (value) => (value ? `V ${value}` : ''),
    },
    {
      title: $i18n.get({
        id: 'aopf.component.workflowManagement.const.UpdateTime',
        dm: '更新时间',
      }),
      dataIndex: 'gmtModified',
      width: 160,
      cell: (value) => formatTime(value),
    },
    {
      title: $i18n.get({ id: 'aopf.component.workflowManagement.const.Operation', dm: '操作' }),
      dataIndex: 'action',
      width: $i18n.language === 'zh-CN' ? 220 : 300,
      lock: 'right',
      cell: (_, _index, record) => (
        <div className="workflow-action-cell">
          <a onClick={() => onItemClick('editAliasName', record)}>
            <img src="https://gw.alicdn.com/imgextra/i3/O1CN01Obijn929RMtIZmHyo_!!6000000008064-2-tps-42-42.png" />
            <span>
              {$i18n.get({
                id: 'aopf.component.workflowManagement.const.WorkflowAlias',
                dm: '工作流别名',
              })}
            </span>
          </a>
          <Divider direction="ver" />
          <a onClick={() => onItemClick('viewVersion', record)}>
            <img src="https://gw.alicdn.com/imgextra/i3/O1CN01a8PvzZ1lMHiW9Q73g_!!6000000004804-2-tps-42-42.png" />
            <span>
              {$i18n.get({
                id: 'aopf.component.workflowManagement.const.VersionManagement',
                dm: '版本管理',
              })}
            </span>
          </a>
        </div>
      ),
    },
  ];
};
